module.exports = __webpack_public_path__ + "static/media/em-100.59b98a8a.png";